export type BdVirtualClinicAdmissionReason =
  | '0101'
  | '0102'
  | '0103'
  | '0104'
  | '0106'
  | '0107'
  | '0201'
  | '0202'
  | '0203'
  | '0204'
  | '0206'
  | '0207'
  | '0301'
  | '0302'
  | '0303'
  | '0304'
  | '0306'
  | '0307'
  | '0401'
  | '0402'
  | '0403'
  | '0404'
  | '0406'
  | '0407'
  | '0501'
  | '0502'
  | '0503'
  | '0504'
  | '0506'
  | '0507'
  | '0601'
  | '0602'
  | '0603'
  | '0604'
  | '0606'
  | '0607'
  | '0701'
  | '0702'
  | '0703'
  | '0704'
  | '0706'
  | '0707'
  | '0801'
  | '0802'
  | '0803'
  | '0804'
  | '0806'
  | '0807'
  | '1001'
  | '1002'
  | '1003'
  | '1004'
  | '1006'
  | '1007'
  | '1201'
  | '1202'
  | '1203'
  | '1204'
  | '1206'
  | '1207'
  | '1208';

export const BD_VIRTUAL_CLINIC_ADMISSION_REASON_DISPLAY_NAMES: {
  [admissionReason in BdVirtualClinicAdmissionReason]: string;
} = {
  '0101': 'Krankenhausbehandlung, vollstationär - Normalfall',
  '0102':
    'Krankenhausbehandlung, vollstationär - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0103':
    'Krankenhausbehandlung, vollstationär - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0104':
    'Krankenhausbehandlung, vollstationär - Hinweis auf Einwirkung von äußerer Gewalt',
  '0106':
    'Krankenhausbehandlung, vollstationär - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0107': 'Krankenhausbehandlung, vollstationär - Notfall',
  '0201':
    'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung  - Normalfall',
  '0202':
    'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung  - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0203':
    'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung  - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0204':
    'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung  - Hinweis auf Einwirkung von äußerer Gewalt',
  '0206':
    'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung  - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0207':
    'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung  - Notfall',
  '0301': 'Krankenhausbehandlung, teilstationär - Normalfall',
  '0302':
    'Krankenhausbehandlung, teilstationär - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0303':
    'Krankenhausbehandlung, teilstationär - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0304':
    'Krankenhausbehandlung, teilstationär - Hinweis auf Einwirkung von äußerer Gewalt',
  '0306':
    'Krankenhausbehandlung, teilstationär - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0307': 'Krankenhausbehandlung, teilstationär - Notfall',
  '0401':
    'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung  - Normalfall',
  '0402':
    'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung  - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0403':
    'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung  - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0404':
    'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung  - Hinweis auf Einwirkung von äußerer Gewalt',
  '0406':
    'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung  - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0407':
    'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung  - Notfall',
  '0501': 'Stationäre Entbindung - Normalfall',
  '0502':
    'Stationäre Entbindung - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0503':
    'Stationäre Entbindung - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0504': 'Stationäre Entbindung - Hinweis auf Einwirkung von äußerer Gewalt',
  '0506': 'Stationäre Entbindung - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0507': 'Stationäre Entbindung - Notfall',
  '0601': 'Geburt - Normalfall',
  '0602': 'Geburt - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0603':
    'Geburt - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0604': 'Geburt - Hinweis auf Einwirkung von äußerer Gewalt',
  '0606': 'Geburt - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0607': 'Geburt - Notfall',
  '0701':
    'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003  - Normalfall',
  '0702':
    'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003  - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0703':
    'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003  - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0704':
    'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003  - Hinweis auf Einwirkung von äußerer Gewalt',
  '0706':
    'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003  - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0707':
    'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003  - Notfall',
  '0801': 'Stationäre Aufnahme zur Organentnahme - Normalfall',
  '0802':
    'Stationäre Aufnahme zur Organentnahme - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '0803':
    'Stationäre Aufnahme zur Organentnahme - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '0804':
    'Stationäre Aufnahme zur Organentnahme - Hinweis auf Einwirkung von äußerer Gewalt',
  '0806':
    'Stationäre Aufnahme zur Organentnahme - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '0807': 'Stationäre Aufnahme zur Organentnahme - Notfall',
  '1001': 'Stationsäquivalente Behandlung  - Normalfall',
  '1002':
    'Stationsäquivalente Behandlung  - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '1003':
    'Stationsäquivalente Behandlung  - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '1004':
    'Stationsäquivalente Behandlung  - Hinweis auf Einwirkung von äußerer Gewalt',
  '1006':
    'Stationsäquivalente Behandlung  - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '1007': 'Stationsäquivalente Behandlung  - Notfall',
  '1201': 'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Normalfall',
  '1202':
    'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Arbeitsunfall / Berufskrankheit (§ 11 Abs. 5 SGB V)',
  '1203':
    'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Verkehrsunfall / Sportunfall / Sonstiger Unfall (z. B. § 116 SGB X)',
  '1204':
    'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Hinweis auf Einwirkung von äußerer Gewalt',
  '1206':
    'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Kriegsbeschädigten-Leiden / BVG-Leiden',
  '1207': 'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Notfall',
  '1208':
    'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG) - Erprobungsleistung nach §137e SGB V',
};

export const BD_VIRTUAL_CLINIC_ADMISSION_REASON_CATEGORIES = {
  '01': 'Krankenhausbehandlung, vollstationär',
  '02': 'Krankenhausbehandlung vollstationär mit vorausgegangener vorstationärer Behandlung',
  '03': 'Krankenhausbehandlung, teilstationär',
  '04': 'Vorstationäre Behandlung ohne anschließende vollstationäre Behandlung',
  '05': 'Stationäre Entbindung',
  '06': 'Geburt',
  '07': 'Wiederaufnahme wegen Komplikationen (Fallpauschale) nach KFPV 2003',
  '08': 'Stationäre Aufnahme zur Organentnahme',
  '10': 'Stationsäquivalente Behandlung',
  '12': 'Krankenhausbehandlung nach §115f SGB V (Hybrid-DRG)',
} as const;

export type AdmissionReasonCategoryLabel =
  (typeof BD_VIRTUAL_CLINIC_ADMISSION_REASON_CATEGORIES)[keyof typeof BD_VIRTUAL_CLINIC_ADMISSION_REASON_CATEGORIES];
